<div class="option-wrapper">
  <div class="variant-wrapper my-2">
    <form class="mx-3 my-4" [formGroup]="specialNoteFg">
      <div class="row ta-wrapper"
        [ngClass]="{'is-invalid': (getControl('specialNote').invalid && (getControl('specialNote').dirty)), 'populated': getControl('specialNote').value.length > 0}">
        <div class="col-md-12 mb-0">
          <div class="form-group mx-2 mb-0">
            <div #igTextarea class="input-group floating-label-wrapper" (click)="helper.focusTextArea(igTextarea)">
              <textarea type="text" class="form-control pb-4 floating-input"
              [class.is-invalid]="getControl('specialNote', 'specialNoteFg').invalid && (getControl('specialNote', 'specialNoteFg').dirty || getControl('specialNote', 'specialNoteFg').touched)"
              autocomplete="street-address" formControlName="specialNote" maxlength="256" rows="2"
              id="specialNote" (focus)="onTextareaFocus()" (blur)="onTextareaBlur()">
          </textarea>
              <label for="specialNote" class="floating-label font-size-primary" [class.float-up]="getControl('specialNote').value || isFocused">
                {{'public.checkout.specialNote' | translate}} {{'public.global.optional' | translate}}
              </label>
            </div>
            <div class="invalid-feedback font-size-secondary" *ngIf="getControl('specialNote').errors">
              <span *ngIf="getControl('specialNote').errors.maxlength">{{'public.payment.errors.valueNotValid' | translate}}</span>
          </div>
        </div>
      </div>
      </div>
    </form>
  </div>
</div>